const ikanoLogo = require("../images/logos/ikanobank-logo.png");
const aionLogo = require("../images/logos/aion-logo.png");
const nestLogo = require("../images/logos/nestbank-logo.png");
const bphLogo = require("../images/logos/bph-logo.png");
const dnbLogo = require("../images/logos/dnb-logo.png");
const toyotaLogo = require("../images/logos/toyotabank-logo.png");
const plusLogo = require("../images/logos/plusbank-logo.png");
const pocztowyLogo = require("../images/logos/pocztowy-logo.png");
const santanderConsumerLogo = require("../images/logos/santanderconsumer-logo.png");
const sgbLogo = require("../images/logos/sgb-logo.png");
const creditagricoleLogo = require("../images/logos/creditagricole-logo.png");
const bpsLogo = require("../images/logos/bankbps-logo.png");
const velobankLogo = require("../images/logos/velobank-logo.png");
const citiLogo = require("../images/logos/citybank-logo.png");
const aliorLogo = require("../images/logos/aliorbank-logo.png");
const millenniumLogo = require("../images/logos/bankmillennium-logo.png");
const bnpparibasLogo = require("../images/logos/bnpparibas-logo.png");
const pekaoLogo = require("../images/logos/pekao-logo.png");
const pkobpLogo = require("../images/logos/pkobp-logo.png");
const ingLogo = require("../images/logos/ing-logo.png");
const ersteLogo = require("../images/logos/erste-logo.png");
const mbankLogo = require("../images/logos/mbank-logo.png");
const bosbankLogo = require("../images/logos/bosbank-logo.png");

const bankLogotypesArray = [
    {
        bankNames: ["BGŻ", "BNP PARIBAS", "BNPPARIBAS"],
        logo: bnpparibasLogo
    },
    {
        bankNames: ["BOŚ", "BOŚ BANK"],

        logo: bosbankLogo
    },
    {
        bankNames: ["MBANK"],

        logo: mbankLogo
    },
    {
        bankNames: ["PEKAO", "PEKAO SA", "PEKAO S.A."],

        logo: pekaoLogo
    },
    {
        bankNames: [
            "ERSTE",
            "ERSTE BANK",
            "ERSTE BANK POLSKA",
            "BANK ERSTE",
            "ERSTE (D. SANTANDER)",
            "ERSTE BANK (D. SANTANDER)",
            "ERSTE BANK POLSKA (D. SANTANDER)",
            "BANK ERSTE (D. SANTANDER)"
        ],

        logo: ersteLogo
    },
    {
        bankNames: ["ING", "ING BANK ŚLĄSKI"],

        logo: ingLogo
    },
    {
        bankNames: ["ALIOR", "ALIOR BANK"],

        logo: aliorLogo
    },
    {
        bankNames: ["PKO", "PKO BP", "PKO BANK POLSKI", "BANK PKO"],

        logo: pkobpLogo
    },
    {
        bankNames: ["MILLENNIUM", "BANK MILLENNIUM", "MILLENNIUM BANK"],

        logo: millenniumLogo
    },
    {
        bankNames: ["AION", "AION BANK"],

        logo: aionLogo
    },
    {
        bankNames: ["CITI", "CITIBANK", "CITIBANK BANK HANDLOWY", "CITI BANK", "CITI HANDLOWY", "CITI BANK HANDLOWY"],

        logo: citiLogo
    },
    {
        bankNames: ["BPH", "BANK BPH", "BANK BPH SA", "BPH SA", "BANK BPH S.A.", "BPH S.A."],

        logo: bphLogo
    },
    {
        bankNames: ["DNB BANK", "DNB", "BANK DBN", "DNB BANK POLSKA"],

        logo: dnbLogo
    },
    {
        bankNames: ["POCZTOWY", "BANK POCZTOWY"],

        logo: pocztowyLogo
    },
    {
        bankNames: ["SANTANDER CONSUMER", "SANTANDER CONSUMER BANK"],

        logo: santanderConsumerLogo
    },
    {
        bankNames: ["SGB", "SGB BANK", "BANK SGB", "BANK SPÓŁDZIELCZY SGB", "SGB-BANK", "SGB BANK SA", "SGB-BANK SA", "SGB BANK S.A.", "SGB-BANK S.A."],

        logo: sgbLogo
    },
    {
        bankNames: ["BPS", "BPS BANK", "BANK BPS", "BANK POLSKIEJ SPÓŁDZIELCZOŚCI"],

        logo: bpsLogo
    },
    {
        bankNames: ["VELO", "VELOBANK", "VELO BANK"],

        logo: velobankLogo
    },
    {
        bankNames: ["CREDIT AGRICOLE", "BANK CREDIT AGRICOLE"],

        logo: creditagricoleLogo
    },
    {
        bankNames: ["PLUS", "PLUS BANK", "PLUS BANK SA", "PLUS BANK S.A."],

        logo: plusLogo
    },
    {
        bankNames: ["NEST", "NESTBANK", "NEST BANK"],

        logo: nestLogo
    },
    {
        bankNames: ["IKANO", "IKANOBANK", "IKANO BANK"],

        logo: ikanoLogo
    },
    {
        bankNames: ["TOYOTA", "TOYOTA FINANCIAL SERVICES"],

        logo: toyotaLogo
    }
];

export const getBankLogo = (bank: string) => {
    const logotype = bankLogotypesArray.find((logotype) => logotype.bankNames.includes(bank.toUpperCase()));

    if (logotype) {
        return logotype.logo;
    }

    return null;
};
const ikanoLogo = require("../images/logos/ikanobank-logo.png");
const aionLogo = require("../images/logos/aion-logo.png");
const nestLogo = require("../images/logos/nestbank-logo.png");
const bphLogo = require("../images/logos/bph-logo.png");
const dnbLogo = require("../images/logos/dnb-logo.png");
const toyotaLogo = require("../images/logos/toyotabank-logo.png");
const plusLogo = require("../images/logos/plusbank-logo.png");
const pocztowyLogo = require("../images/logos/pocztowy-logo.png");
const santanderConsumerLogo = require("../images/logos/santanderconsumer-logo.png");
const sgbLogo = require("../images/logos/sgb-logo.png");
const creditagricoleLogo = require("../images/logos/creditagricole-logo.png");
const bpsLogo = require("../images/logos/bankbps-logo.png");
const velobankLogo = require("../images/logos/velobank-logo.png");
const citiLogo = require("../images/logos/citybank-logo.png");
const aliorLogo = require("../images/logos/aliorbank-logo.png");
const millenniumLogo = require("../images/logos/bankmillennium-logo.png");
const bnpparibasLogo = require("../images/logos/bnpparibas-logo.png");
const pekaoLogo = require("../images/logos/pekao-logo.png");
const pkobpLogo = require("../images/logos/pkobp-logo.png");
const ingLogo = require("../images/logos/ing-logo.png");
const ersteLogo = require("../images/logos/erste-logo.png");
const mbankLogo = require("../images/logos/mbank-logo.png");
const bosbankLogo = require("../images/logos/bosbank-logo.png");

const bankLogotypesArray = [
    {
        bankNames: ["BGŻ", "BNP PARIBAS", "BNPPARIBAS"],
        logo: bnpparibasLogo
    },
    {
        bankNames: ["BOŚ", "BOŚ BANK"],

        logo: bosbankLogo
    },
    {
        bankNames: ["MBANK"],

        logo: mbankLogo
    },
    {
        bankNames: ["PEKAO", "PEKAO SA", "PEKAO S.A."],

        logo: pekaoLogo
    },
    {
        bankNames: [
            "ERSTE",
            "ERSTE BANK",
            "ERSTE BANK POLSKA",
            "BANK ERSTE",
            "ERSTE (D. SANTANDER)",
            "ERSTE BANK (D. SANTANDER)",
            "ERSTE BANK POLSKA (D. SANTANDER)",
            "BANK ERSTE (D. SANTANDER)"
        ],

        logo: ersteLogo
    },
    {
        bankNames: ["ING", "ING BANK ŚLĄSKI"],

        logo: ingLogo
    },
    {
        bankNames: ["ALIOR", "ALIOR BANK"],

        logo: aliorLogo
    },
    {
        bankNames: ["PKO", "PKO BP", "PKO BANK POLSKI", "BANK PKO"],

        logo: pkobpLogo
    },
    {
        bankNames: ["MILLENNIUM", "BANK MILLENNIUM", "MILLENNIUM BANK"],

        logo: millenniumLogo
    },
    {
        bankNames: ["AION", "AION BANK"],

        logo: aionLogo
    },
    {
        bankNames: ["CITI", "CITIBANK", "CITIBANK BANK HANDLOWY", "CITI BANK", "CITI HANDLOWY", "CITI BANK HANDLOWY"],

        logo: citiLogo
    },
    {
        bankNames: ["BPH", "BANK BPH", "BANK BPH SA", "BPH SA", "BANK BPH S.A.", "BPH S.A."],

        logo: bphLogo
    },
    {
        bankNames: ["DNB BANK", "DNB", "BANK DBN", "DNB BANK POLSKA"],

        logo: dnbLogo
    },
    {
        bankNames: ["POCZTOWY", "BANK POCZTOWY"],

        logo: pocztowyLogo
    },
    {
        bankNames: ["SANTANDER CONSUMER", "SANTANDER CONSUMER BANK"],

        logo: santanderConsumerLogo
    },
    {
        bankNames: ["SGB", "SGB BANK", "BANK SGB", "BANK SPÓŁDZIELCZY SGB", "SGB-BANK", "SGB BANK SA", "SGB-BANK SA", "SGB BANK S.A.", "SGB-BANK S.A."],

        logo: sgbLogo
    },
    {
        bankNames: ["BPS", "BPS BANK", "BANK BPS", "BANK POLSKIEJ SPÓŁDZIELCZOŚCI"],

        logo: bpsLogo
    },
    {
        bankNames: ["VELO", "VELOBANK", "VELO BANK"],

        logo: velobankLogo
    },
    {
        bankNames: ["CREDIT AGRICOLE", "BANK CREDIT AGRICOLE"],

        logo: creditagricoleLogo
    },
    {
        bankNames: ["PLUS", "PLUS BANK", "PLUS BANK SA", "PLUS BANK S.A."],

        logo: plusLogo
    },
    {
        bankNames: ["NEST", "NESTBANK", "NEST BANK"],

        logo: nestLogo
    },
    {
        bankNames: ["IKANO", "IKANOBANK", "IKANO BANK"],

        logo: ikanoLogo
    },
    {
        bankNames: ["TOYOTA", "TOYOTA FINANCIAL SERVICES"],

        logo: toyotaLogo
    }
];

export const getBankLogo = (bank: string) => {
    const logotype = bankLogotypesArray.find((logotype) => logotype.bankNames.includes(bank.toUpperCase()));

    if (logotype) {
        return logotype.logo;
    }

    return null;
};
